import { configureStore } from "@reduxjs/toolkit";
import { baseApi } from "./slices/apiSlice";
import appSlice from "./slices/appSlice";
import pagesSlice from "./slices/pagesSlice";

export const store = configureStore({
  reducer: {
    app: appSlice,
    pages: pagesSlice,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["pages/setMap", "pages/setWorkspace"],
        ignoredPaths: ["pages.truterritory.map", "pages.truterritory.workspace", "pages.truterritory.currentThemes"],
      },
    }).concat(baseApi.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
